import React from "react";
import {connect} from "react-redux";
import {EyeInvisibleOutlined, LockOutlined} from "@ant-design/icons";
import {Tag} from "antd";
import AccountSystemTypeLabel from "bukku/components/Label/AccountSystemType";
import AmountTd from "bukku/components/Table/Common/AmountTd";

export const AccountCodeCell = connect()(
    props => {
        const { record } = props;
        if (record.is_heading)
            return <h4 style={{textAlign: "left"}}>{record.label}</h4>;
        return record.code || '';
    },
);

export const AccountCell = connect()(
    props => {
        const { text, record } = props;
        return (
            <div>
                <span>{text}</span>
                &nbsp;
                { record.is_archived ? (
                    <span>
                        <EyeInvisibleOutlined />
                    &nbsp;
                    </span>) : null}
                { record.is_locked ? (
                    <span>
                        <LockOutlined />
                    &nbsp;
                    </span>) : null}
            </div>);
    },
);

export const SystemTypeCell = connect()(
    props => {
        const { record } = props;
        if (record.system_type)
            return <Tag><AccountSystemTypeLabel value={record.system_type} /></Tag>;
        return null;
    },
);

export const AmountCell = connect()(
    props => {
        const { text, record } = props;
        return text === null ?
            '' : <AmountTd
                currency_code={record?.currency?.code}
                amount={text}
                doNotReadLists
            />;
    },
);
